import { gql } from "@apollo/client";

const GET_PROFILE = gql`
    query GetProfile {
        perfil {
            id
            nombres
            apellidos
            fechaRegistro
            dni
            profesion
            cargo
            empresa
            cuenta {
                id
                usuario
            }
            emails {
                id
                direccion
                principal
                confirmado
                tipoEmail
            }
            telefonos {
                id
                numero
                principal
                tipoTelefono
            }
            direcciones {
                id
                direccion
                distrito
                distritoId
                ciudad
                ciudadId
                departamento
                departamentoId
                pais
                paisId
                referencia
                principal
            }
        }
    }
`;

export default GET_PROFILE;
